import * as React from 'react';
import { List as MatList, SxProps, Theme } from '@mui/material';

export interface ListProps {
  className?: string;
  dense?: boolean;
  disablePadding?: boolean;
  subheader?: JSX.Element;
  children?: React.ReactNode;
  component?: 'ul' | 'li' | 'nav';
  role?: string;
  ref?: any;
  sx?: SxProps<Theme>;
}

const List: React.FunctionComponent<ListProps> = React.forwardRef(
  ({ children, subheader, dense, disablePadding, className, sx, ...rest }: ListProps, ref: any) => {
    return (
      <MatList subheader={subheader} dense={dense} disablePadding={disablePadding} className={className} sx={sx} ref={ref} {...rest}>
        {children}
      </MatList>
    );
  }
);

List.displayName = 'List';

export { List };
